var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.className,attrs:{"width":240,"size":"xs"}},[_c('v-card-title',{style:({ backgroundColor: _vm.bgColor })},[_c('h4',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.textInfo))])]),_c('v-card-actions',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }